import * as t from 'io-ts';
import { ArrayOperator, NumberOperator, StringOperator, TimeOperator } from './operator';
export var StringInterface = t.type({
  string_value: t.string,
  operator: StringOperator
});
export var NumberInterface = t.type({
  number_value: t.number,
  operator: NumberOperator
});
export var StringArrayInterface = t.type({
  string_array_value: t.array(t.string),
  operator: ArrayOperator
});
export var MsAgoInterface = t.type({
  milliseconds_ago_value: t.number,
  operator: TimeOperator
});